// import { post, get } from '../http/axios';
// import { param } from 'cypress/types/jquery';
import service from '../http/axios';

// export const getVerCodeApi = appConfig => {
//   return get(
//     appConfig.servers.apiServer[0].baseUrl + 'yinghe-api/getVerCode',
//     '',
//     { responseType: 'blob' }
//   ).catch(err => {
//     console.log(err);
//     return err;
//   });
// };

// export const loginApi = (payload, appConfig) => {
//   return post(
//     appConfig.servers.apiServer[0].baseUrl + 'yinghe-api/login',
//     payload,
//     { withCredentials: true }
//   ).catch(err => {
//     console.log(err);
//     return err;
//   });
// };

export const getVerCodeApi = service({
  responseType: 'blob',
  url: 'yinghe-api/getVerCode',
});

export const loginApi = service({
  method: 'POST',
  url: 'yinghe-api/login',
});
